define([
	"dojo/_base/declare",
	"Apparel/NewMaterialSample"
], function(declare,NewMaterialSample) {

	return declare(NewMaterialSample, {
		getFormData: function() {
			// summary: trick csi.form.Widget.getFormNode into using Material as parent, not MaterialColor
			var	fd = this.inherited(arguments);
			fd.m_parentNode = this.m_cache.getNode(fd.getParent().__Parent__, true);
			return fd;
		}
	});
});